import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4735c10f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "admin-users",
  class: "admin-card"
}
const _hoisted_2 = {
  key: 0,
  class: "no-users"
}
const _hoisted_3 = {
  key: 1,
  class: "responsive-table"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "#", -1))
const _hoisted_5 = { class: "left-text" }
const _hoisted_6 = { class: "left-text" }
const _hoisted_7 = { class: "left-text" }
const _hoisted_8 = { class: "cell-heading" }
const _hoisted_9 = { class: "cell-heading" }
const _hoisted_10 = { class: "cell-heading" }
const _hoisted_11 = { class: "cell-heading" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { class: "cell-heading" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = { class: "cell-heading" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = { class: "cell-heading" }
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = { class: "cell-heading" }
const _hoisted_20 = ["disabled", "onClick"]

import { format } from 'date-fns'
  import {
    ComputedRef,
    Ref,
    computed,
    reactive,
    watch,
    capitalize,
    onBeforeMount,
    onUnmounted,
  } from 'vue'
  import { LocationQuery, useRoute, useRouter } from 'vue-router'

  import FilterSelects from '@/components/Common/FilterSelects.vue'
  import Pagination from '@/components/Common/Pagination.vue'
  import UserPicture from '@/components/User/UserPicture.vue'
  import UsersNameFilter from '@/components/Users/UsersNameFilter.vue'
  import { AUTH_USER_STORE, ROOT_STORE, USERS_STORE } from '@/store/constants'
  import { IPagination, TPaginationPayload } from '@/types/api'
  import { IAuthUserProfile, IUserProfile } from '@/types/user'
  import { useStore } from '@/use/useStore'
  import { getQuery, sortList } from '@/utils/api'
  import { getDateWithTZ } from '@/utils/dates'

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const store = useStore()
  const route = useRoute()
  const router = useRouter()

  const orderByList: string[] = [
    'is_active',
    'admin',
    'created_at',
    'username',
    'workouts_count',
  ]
  const defaultOrderBy = 'created_at'
  let query: TPaginationPayload = reactive(
    getQuery(route.query, orderByList, defaultOrderBy)
  )
  const authUser: ComputedRef<IAuthUserProfile> = computed(
    () => store.getters[AUTH_USER_STORE.GETTERS.AUTH_USER_PROFILE]
  )
  const users: ComputedRef<IUserProfile[]> = computed(
    () => store.getters[USERS_STORE.GETTERS.USERS]
  )
  const pagination: ComputedRef<IPagination> = computed(
    () => store.getters[USERS_STORE.GETTERS.USERS_PAGINATION]
  )
  const errorMessages: ComputedRef<string | string[] | null> = computed(
    () => store.getters[ROOT_STORE.GETTERS.ERROR_MESSAGES]
  )

  onBeforeMount(() => loadUsers(query))

  function loadUsers(queryParams: TPaginationPayload) {
    store.dispatch(USERS_STORE.ACTIONS.GET_USERS, queryParams)
  }
  function searchUsers(username: Ref<string>) {
    reloadUsers('q', username.value)
  }

  function updateUser(username: string, admin: boolean) {
    store.dispatch(USERS_STORE.ACTIONS.UPDATE_USER, {
      username,
      admin,
    })
  }
  function reloadUsers(queryParam: string, queryValue: string) {
    query[queryParam] = queryValue
    if (queryParam === 'per_page') {
      query.page = 1
    }
    router.push({ path: '/admin/users', query })
  }

  onUnmounted(() => {
    store.dispatch(USERS_STORE.ACTIONS.EMPTY_USERS)
  })

  watch(
    () => route.query,
    (newQuery: LocationQuery) => {
      query = getQuery(newQuery, orderByList, defaultOrderBy, { query })
      loadUsers(query)
    }
  )

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Card, null, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(capitalize(_ctx.$t('admin.USER', 0))), 1)
      ]),
      content: _withCtx(() => [
        _createElementVNode("button", {
          class: "top-button",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.push('/admin')), ["prevent"]))
        }, _toDisplayString(_ctx.$t('admin.BACK_TO_ADMIN')), 1),
        _createVNode(UsersNameFilter, { onFilterOnUsername: searchUsers }),
        _createVNode(FilterSelects, {
          sort: _unref(sortList),
          order_by: orderByList,
          query: _unref(query),
          message: "admin.USERS.SELECTS.ORDER_BY",
          onUpdateSelect: reloadUsers
        }, null, 8, ["sort", "query"]),
        (_unref(users).length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('user.NO_USERS_FOUND')), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("table", null, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_4,
                    _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t('user.USERNAME')), 1),
                    _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t('user.EMAIL')), 1),
                    _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t('user.PROFILE.REGISTRATION_DATE')), 1),
                    _createElementVNode("th", null, _toDisplayString(capitalize(_ctx.$t('workouts.WORKOUT', 0))), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('admin.ACTIVE')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('user.ADMIN')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('admin.ACTION')), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(users), (user) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: user.username
                    }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('user.PROFILE.PICTURE')), 1),
                        _createVNode(UserPicture, { user: user }, null, 8, ["user"])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('user.USERNAME')), 1),
                        _createVNode(_component_router_link, {
                          to: `/admin/users/${user.username}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(user.username), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('user.EMAIL')), 1),
                        _createTextVNode(" " + _toDisplayString(user.email), 1)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('user.PROFILE.REGISTRATION_DATE')), 1),
                        _createTextVNode(" " + _toDisplayString(_unref(format)(
                      _unref(getDateWithTZ)(user.created_at, _unref(authUser).timezone),
                      'dd/MM/yyyy HH:mm'
                    )), 1)
                      ]),
                      _createElementVNode("td", _hoisted_12, [
                        _createElementVNode("span", _hoisted_13, _toDisplayString(capitalize(_ctx.$t('workouts.WORKOUT', 0))), 1),
                        _createTextVNode(" " + _toDisplayString(user.nb_workouts), 1)
                      ]),
                      _createElementVNode("td", _hoisted_14, [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('admin.ACTIVE')), 1),
                        _createElementVNode("i", {
                          class: _normalizeClass(`fa fa${user.is_active ? '-check' : ''}-square-o`),
                          "aria-hidden": "true"
                        }, null, 2)
                      ]),
                      _createElementVNode("td", _hoisted_16, [
                        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('user.ADMIN')), 1),
                        _createElementVNode("i", {
                          class: _normalizeClass(`fa fa${user.admin ? '-check' : ''}-square-o`),
                          "aria-hidden": "true"
                        }, null, 2)
                      ]),
                      _createElementVNode("td", _hoisted_18, [
                        _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('admin.ACTION')), 1),
                        _createElementVNode("button", {
                          class: _normalizeClass({ danger: user.admin }),
                          disabled: user.username === _unref(authUser).username,
                          onClick: ($event: any) => (updateUser(user.username, !user.admin))
                        }, _toDisplayString(_ctx.$t(
                        `admin.USERS.TABLE.${
                          user.admin ? 'REMOVE' : 'ADD'
                        }_ADMIN_RIGHTS`
                      )), 11, _hoisted_20)
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              (_unref(pagination).page)
                ? (_openBlock(), _createBlock(Pagination, {
                    key: 0,
                    path: "/admin/users",
                    pagination: _unref(pagination),
                    query: _unref(query)
                  }, null, 8, ["pagination", "query"]))
                : _createCommentVNode("", true),
              (_unref(errorMessages))
                ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                    key: 1,
                    message: _unref(errorMessages)
                  }, null, 8, ["message"]))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$router.push('/admin')), ["prevent"]))
              }, _toDisplayString(_ctx.$t('admin.BACK_TO_ADMIN')), 1)
            ]))
      ]),
      _: 1
    })
  ]))
}
}

})